

































































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import {ActionsEnum} from "@/entity/ActionsEnum";
import ImageShow from "@/components/ImageShow.vue";
class comments {
    comment_id:String = "";
    name: String = "";
    lastname: String = "";
    email: String = "";
    user_id: number|null = null;
    product_id: number|null = null;
    point: number|null = null;
    image_data: [] = [];
    description: String = "";
    enabled: number|null = null;
    created_at: String = "";
    updated_at: String = "";
}
@Component({
    components: {
        DeleteButton,EForm,Number,TextField,Id,EnabledSwitch,ImageShow
    }
})
export default class Comments extends  Vue{
    items : comments[] | null = null;
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = ActionsEnum.Comments;
    action:string = this.baseAction;
    editing:boolean=false;
    data : comments = new comments();
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "comment_id"
        },
        {text: "Ad", value: "name"},
        {text: "Soyad", value: "lastname"},
        {text: "E-Posta", value: "email"},
        {text: "Puan", value: "point"},
        {text: "Mesaj", value: "description"},
        {text: "Enabled",  value: "enabled"},
        {text: "İşlemler", value: "actions"}
    ];
    edit(item:comments){
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.comment_id;
        this.dialog = true;
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new comments();
        this.dialog = true;
    }
    async get(){
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }
    created(){
        this.get();
    }
};
